<template>
  <div class="footer ">
    <div class="ft-wh dis-flx al-c ju-c">
      <div class="wh-7" style="width:60%">
        <div class="dis-flx al-c">
          <img src="../../assets/images/zhihelogo.png" style="width:200px" alt="">
        </div>
        <!-- <div class="link_sy">
          <span>相关链接：</span>
          <span @click="jumpG" style="cursor:pointer;">国家知识产权局</span>
          <span @click="jumps" style="cursor:pointer;">陕西知识产权局</span>
        </div> -->
        <!-- <p class="ct-ft mt-20">陕西XXXXXX有限公司</p>
        <p class="ct-ft mt-5">本文所列数据均通过合法手段由公开渠道信息加工整理而来，不构成任何投资建议。如涉及用户或企业隐私、数据错误等问题， 请及时与我们联系，我们将在收到后的第一时间予以处理。</p> -->
      </div>
      <div style="width:40%">
        <div class="dis-flx al-c wz-3 lh-30">
          <div>
            <div>
              <img src="../../assets/images/u：calling.png" style="width:13px;height:13px" alt="">
              <span class="info-sz">联系电话</span>
              <p class="inft2-sz">{{contactInfo.contactTelephone}}</p>
            </div>
            <div>
              <img src="../../assets/images/u：envelope-alt.png" style="width:13px;height:13px" alt="">
              <span class="info-sz">邮箱地址</span>
              <p class="inft2-sz">{{contactInfo.contactEmail}}</p>
            </div>
            <div>
              <img src="../../assets/images/u：webcam.png" style="width:13px;height:13px" alt="">
              <span class="info-sz">公司地址</span>
            </div>
          </div>
          <div class="ml-10"><img :src="contactInfo.contactQrcode" style="width:142px;height:130px" alt=""></div>
        </div>
        <p class="adr-sz ml-20" style="width:100%;margin-right: 120px;">{{contactInfo.contactAddress}}</p>
      </div>
    </div>
    <div class="ft-wh">
      <hr style="border: 1px solid #E6EFFF;">
      <p class="fot-sz txt-c mt-20">Copyright © 2023 西安复都物业管理有限公司 版权所有 <el-link href="https://beian.miit.gov.cn/" target="_blank" style="color: ##A4AAB8">陕ICP备2023008464号-1</el-link></p>
    </div>

  </div>
</template>
<script>
import { contactInfo } from "@/api/footer";
export default {
  data() {
    return {
      contactInfo:{}
    };
  },
  methods: {
    jumpG() {
      window.open('https://www.cnipa.gov.cn/', '_blank')
    },
    jumps() {
      window.open('http://snipa.shaanxi.gov.cn/', '_blank')
    }
  },
  mounted() {
    var that = this
    contactInfo({contactType:1}).then(res => {
      if (res.code == 200) {
        // console.log(res.data.records, 'res.dfasfdsfsdfsd')
        that.contactInfo = res.data
      } else {
        this.$message({
          type: "error",
          message: res.msg
        });
      }
    });
  },
};
</script>
<style lang="less" scoped>

.mt-20 {
  margin-top: 20px;
}

.footer {
  width: 100%;
  height: 319px;
  background: #FFFFFF;
  box-shadow: 4px 0px 10px 0px #E7EDF8;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-top: 30px;
}

.ft-wh {
  // padding: 20px 260px;
  padding:20px 0;
  width:1200px;
  min-width: 1200px;
  margin:0 auto;
}

.wh-7 {
  padding-right: 200px;
}

.ft-sz-16 {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 19px;
}

.ft-sz-9 {
  font-size: 9px;
  font-weight: 400;
  color: #989391;
  line-height: 11px;
}

.link_sy {
  font-size: 16px;
  font-weight: 400;
  color: #4A6CB1;
  line-height: 19px;
  margin-top: 20px;
}

.link_sy span {
  margin-right: 10px;
}

.lh-30 {
  line-height: 30px;
}

.ct-ft {
  font-size: 15px;
  font-weight: 400;
  color: #656C7C;
  line-height: 18px;
}

.mt-5 {
  margin-top: 5px;
}

.info-sz {
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.inft2-sz {
  font-size: 15px;
  font-weight: 400;
  color: #656C7C;
  line-height: 18px;
  margin-left: 20px;
}

.adr-sz {
  font-size: 15px;
  font-weight: 400;
  color: #656C7C;
  line-height: 18px;
}

.fot-sz {
  font-size: 13px;
  font-weight: 400;
  color: #A4AAB8;
  line-height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue